import CustomerList from './CustomerList.vue';

export { CustomerList };

export default {
  CustomerList,
};
